import { api } from "constants/RotasAPI";
import useDelete from "hooks/useDelete";
import { toast } from "react-hot-toast";
import { queryClient } from "shared/util/queryClient";

export const useDeleteCobrancaProcessoJudicial = () => {
  const onSuccess = (request: number, resposne: any) => {
    if (resposne?.errorMessage) {
      toast.error(resposne?.errorMessage);
    } else {
      toast.success("Cobrança excluída com sucesso!");
      queryClient.invalidateQueries(["cobrancas-vinculadas-ao-processo"]);
      queryClient.invalidateQueries(["selecionar-cobrancas-processo-judicial"]);
      queryClient.invalidateQueries(["processos-judiciais-historicos"]);
    }
  };

  return useDelete<number>({
    url: api.processosJudiciaisContaReceber.deleteCobrancaVinculadaAoProcesso,
    onSuccess,
  });
};
